import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=aafd2c6e&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=ts"
export * from "./TabNavigation.vue?vue&type=script&lang=ts"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=aafd2c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafd2c6e",
  null
  
)

export default component.exports